// Final background-only RGB multipliers. No stored test profile is consulted.
export const DIMMING = Object.freeze({light:10, dark:35});
export const palette = theme => ({dimming: DIMMING[theme === 'dark' ? 'dark' : 'light']});
export function dimColor(color, dimming = 0) {
  const factor = 1 - Math.max(0, Math.min(100, Number(dimming) || 0)) / 100;
  return '#' + color.slice(1).match(/../g).map(v => Math.round(parseInt(v, 16) * factor).toString(16).padStart(2, '0')).join('');
}

export function colorContrast(a,b) {
  const lum=s=>s.slice(1).match(/../g).map(v=>parseInt(v,16)/255).map(v=>v<=.04045?v/12.92:((v+.055)/1.055)**2.4).reduce((n,v,i)=>n+v*[.2126,.7152,.0722][i],0);
  const x=lum(a),y=lum(b);return (Math.max(x,y)+.05)/(Math.min(x,y)+.05);
}
